
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { ExamResult } from '@/services/db/types';
import { format } from 'date-fns';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<boolean>; // This is the prop we need to use
  examResult: ExamResult;
}

const DeleteConfirmDialog = ({
  isOpen,
  onClose,
  onDelete,
  examResult,
}: DeleteConfirmDialogProps) => {
  const handleDelete = async () => {
    const success = await onDelete();
    if (success) {
      onClose();
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Exam Result</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this exam result for{' '}
            <span className="font-medium">{examResult.subject}</span> on{' '}
            <span className="font-medium">
              {format(new Date(examResult.examDate), 'dd MMM yyyy')}
            </span>?
            <br /><br />
            This action cannot be undone and all data associated with this exam result will be permanently deleted.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} className="bg-red-500 hover:bg-red-600">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteConfirmDialog;
